/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CompositionProductVariant {
  compositionId?: number;
  compositionName?: string;
  dateCreated?: Date;
  dateSyncERP?: Date;
  editionId?: number;
  editionName?: string;
  internalEAN?: string;
  productId?: number;
  productVariantCount?: number;
  productVariantId?: number;
  productVariantName?: string;
  quantity?: number;
  salePrice?: number;
  subscriberCount?: number;
}
